<template>
  <div class="menu-banner">
    <div class="menu-container" @mouseleave="bannerMenuHide()">
      <ul class="menu-list">
        <li class="list-item"
        v-for="category in categories"
        :key="category.id"
        @mouseenter="bannerMenuShow(category.id)">
          <a href="javascript:;" @click="goToCategoryList(category.id)">{{category.name}}</a>
          <i class="fa fa-angle-right"></i>
        </li>
      </ul>
    </div>
    <div class="menu-info"
    v-show="bannerMenuFlag"
    @mouseleave="bannerMenuHide()"
    @mouseenter="bannerMenuShow()">
        <ul class="menu-info-list" v-if="subCategories.length > 0">
          <li class="info-list-item"
          v-for="subCategory in subCategories"
          :key="subCategory.id">
            <a href="javascript:;" @click="goToCategoryList(subCategory.id)">
				<span class="">{{subCategory.name}}</span>
            </a>
          </li>
        </ul>
      </div>
    <banner :banners="banners"></banner>
  </div>
</template>

<script>
import Banner from './Banner'
import { getFirstLevelCategories, getSubCategoriesByParentId } from '@/apis/ProductCard'

// 菜单横幅组件：用于展示左侧分类菜单和右侧轮播图，支持鼠标悬停显示对应分类商品
export default {
  data () {
    return {
      bannerMenuFlag: false,
      menuTimer: '',
      categories: [], // 一级分类列表
      subCategories: [], // 当前选中分类的子分类
      currentCategoryId: null, // 当前选中的分类ID
      banners: [
        {src: require('../../assets/image/轮播1.png'), url: 'https://mall.bilibili.com/act/aicms/ukcvyMoC_B.html?msource=mall_piaowu_pc_43583_banner&from=pwng-pc'},
        {src: require('../../assets/image/轮播2.jpg'), url: 'https://show.bilibili.com/platform/detail.html?msource=mall_piaowu_pc_43713_banner&id=111644&from=pwng-pc'},
       ]
      
    }
  },
  methods: {
    // 跳转到分类商品列表
    goToCategoryList(categoryId) {
      this.$router.push({
        path: '/products',
        query: { categoryId }
      }).catch(err => {
        if (err.name !== 'NavigationDuplicated') {
          console.error(err);
        }
      });
    },
    bannerMenuHide () {
      this.menuTimer = setTimeout(() => {
			this.bannerMenuFlag = false;
			this.subCategories = [];
			this.currentCategoryId = null;
		}, 300);
    },
    bannerMenuShow (categoryId) {
      if (categoryId && categoryId !== this.currentCategoryId) {
        this.currentCategoryId = categoryId;
        // 调用API获取子分类
        getSubCategoriesByParentId(categoryId).then(res => {
          if (res.code === 200 && res.data) {
            this.subCategories = res.data;
          } else {
            this.subCategories = [];
          }
        }).catch(err => {
          console.error('获取子分类失败:', err);
          this.subCategories = [];
        });
      }

      this.bannerMenuFlag = true;
      clearTimeout(this.menuTimer);
    },
    // 获取一级分类
    getCategories() {
      getFirstLevelCategories().then(res => {
        if (res.code === 200 && res.data) {
          this.categories = res.data;
        } else {
          this.categories = [];
        }
      }).catch(err => {
        console.error('获取分类失败:', err);
        this.categories = [];
      });
    }
  },
  mounted() {
    // 加载分类数据
    this.getCategories();
  },
  components: {
    'Banner': Banner
  }
}
</script>

<style lang="less">
.menu-banner {
  position: relative;
  width: 100%;
  height: auto;
  margin: 0;
  .menu-container {
    position: absolute;
    left: 0;
    top: 0;
    width: 235px;
    height: 460px;
    background: linear-gradient(180deg, rgba(31, 36, 68, 0.7) 0%, rgba(76, 90, 170, 0.5) 55%, rgba(0, 212, 255, 0.35) 100%);
    z-index: 10;
    backdrop-filter: blur(6px);
    border-radius: 12px 0 0 12px;
    border: 1px solid rgba(255, 255, 255, 0.12);
  }
}

.menu-list {
  height: 460px;
  .list-item {
    display: flex;
    padding-left: 30px;
    position: relative;
    &:hover {
      background-color: #6c7bff;
    }

    a {
      position: relative;
      display: inline-block;
      width: 170px;
      height: 42px;
      line-height: 42px;
      color: #fff;
      text-align: left;
      background-color: transparent;
    }

    i {
      font-size: 22px;
      color: #e0e0e0;
      line-height: 42px;
    }
    &:hover::after {
      content: '';
      position: absolute;
      left: 0;
      top: 10px;
      bottom: 10px;
      width: 3px;
      background: linear-gradient(180deg, #00d4ff 0%, #6c7bff 60%, #ff7bd5 100%);
      border-radius: 2px;
    }
  }
}

.menu-info {
  position: absolute;
  display: flex;
  flex-flow: row nowrap;
  justify-content: flex-start;
  left: 235px;
  top: 0;
  z-index: 11;
  border: 1px solid #e3e8ff;
  box-shadow: 3px 8px 16px rgba(108, 123, 255, 0.12);
  .menu-info-list {
    width: 248px;
    height: 458px;
    margin: 0;
    padding: 0;
    list-style: none;
    background: #fff;
    a {
      display: flex;
      padding: 18px 20px;
      line-height: 40px;
      color: #333;
      img {
        width: 40px;
        height: 40px;
        margin-right: 12px;
        vertical-align: middle;
      }

      span {
        width: 172px;
        line-height: 40px;
        font-size: 14px;
        text-align: start;
        white-space: nowrap;
        text-overflow: ellipsis;
        overflow: hidden;
      }

      &:hover {
        span {
          color: #6c7bff;
        }
      }
    }
  }
}
</style>
